<script lang="ts">
  import type { BankAccount } from "../types";
  import { formatUkBankSummary } from "../../../lib/formatting";
  import FooterButtons from "../../../components/workflow/FooterButtons.svelte";
  import ContinueButton from "../../../components/workflow/ContinueButton.svelte";

  let {
    existingBankAccounts,
    selectedOption = $bindable(),
    errors = null,
  }: {
    existingBankAccounts: BankAccount[];
    selectedOption: string | undefined;
    errors?: { [key: string]: string } | null;
  } = $props();
</script>

<h2 class="ui-title">Add bank account</h2>

<fieldset class="ui-fieldset">
  <legend>Choose how you’d like to receive payment.</legend>

  {#each existingBankAccounts as bankAccount}
    <div class="ui-option-container">
      <label class="flex flex-row gap-2 items-start mt-3">
        <input
          type="radio"
          name="bank_account[id]"
          value={bankAccount.id}
          bind:group={selectedOption}
          class="radio"
          required
        >
        <div>
          <div class="mb-2">Use existing bank account</div>
          <div class="text-xs text-gray-500 mb-1">
            <div>{bankAccount.bankName}</div>
            <div>{bankAccount.copAccountHolder || bankAccount.accountHolder}</div>
            <div>{formatUkBankSummary(bankAccount.accountNumber, bankAccount.sortCode)}</div>
          </div>
        </div>
      </label>
    </div>
  {/each}

  <div class="ui-option-container">
    <label class="flex flex-row gap-2 items-start">
      <input
        type="radio"
        name="bank_account[id]"
        value=""
        bind:group={selectedOption}
        class="radio"
        required
      >
      <div>Enter bank details manually</div>
    </label>
  </div>
</fieldset>

<FooterButtons>
  {#if selectedOption}
    <ContinueButton type="submit" label="Confirm" />
  {:else}
    <ContinueButton type="button" />
  {/if}
</FooterButtons>
